<template>
  <div class="d-inline-flex align-items-center">
    <b-input-group>
      <b-input-group-text slot="prepend" @click.prevent="changeDateFrom(-1)">
        <i class="fa fa-fw fa-angle-left"></i>
      </b-input-group-text>
      <datepicker
        :id="idPrefix + '-date-from'"
        v-model="localDateFrom"
        :language="lang"
        :monday-first="true"
        format="dd.MM.yyyy"
        :typeable="false"
        @input="onDateFromChange"
      ></datepicker>
      <b-input-group-text slot="append" @click.prevent="changeDateFrom(1)">
        <i class="fa fa-fw fa-angle-right"></i>
      </b-input-group-text>
    </b-input-group>
    <span class="mx-2">–</span>
    <b-input-group>
      <b-input-group-text slot="prepend" @click.prevent="changeDateTo(-1)">
        <i class="fa fa-fw fa-angle-left"></i>
      </b-input-group-text>
      <datepicker
        :id="idPrefix + '-date-to'"
        v-model="localDateTo"
        :language="lang"
        :monday-first="true"
        format="dd.MM.yyyy"
        :typeable="false"
        :disabled-dates="disabledDatesTo"
        @input="onDateToChange"
      ></datepicker>
      <b-input-group-text slot="append" @click.prevent="changeDateTo(1)">
        <i class="fa fa-fw fa-angle-right"></i>
      </b-input-group-text>
    </b-input-group>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { is } from 'vuejs-datepicker/dist/locale';

export default {
  name: 'DateRangeFilter',
  components: { Datepicker },
  props: {
    dateFrom: { type: Date, default: null },
    dateTo: { type: Date, default: null },
    idPrefix: { type: String, default: 'date-range' },
  },
  data() {
    return {
      localDateFrom: this.dateFrom,
      localDateTo: this.dateTo,
      lang: is,
    };
  },
  computed: {
    disabledDatesTo() {
      if (!this.localDateFrom) return {};
      return { to: moment(this.localDateFrom).subtract(1, 'day').toDate() };
    },
  },
  methods: {
    changeDateFrom(delta) {
      if (this.localDateFrom) {
        this.localDateFrom = moment(this.localDateFrom).add(delta, 'days').toDate();
        this.onDateFromChange(this.localDateFrom);
      }
    },
    changeDateTo(delta) {
      if (this.localDateTo) {
        this.localDateTo = moment(this.localDateTo).add(delta, 'days').toDate();
        this.onDateToChange(this.localDateTo);
      }
    },
    onDateFromChange(val) {
      if (this.localDateTo && val && this.localDateTo < val) {
        this.localDateTo = null;
        this.$emit('update:dateTo', null);
      }
      this.$emit('update:dateFrom', val);
      this.$emit('change', { dateFrom: val, dateTo: this.localDateTo });
    },
    onDateToChange(val) {
      this.$emit('update:dateTo', val);
      this.$emit('change', { dateFrom: this.localDateFrom, dateTo: val });
    },
  },
};
</script>
